/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addedtoshortlist3Inputs */

const en_coinvestments_addedtoshortlist3 = /** @type {(inputs: Coinvestments_Addedtoshortlist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations successfully added to shortlist`)
};

/**
* | output |
* | --- |
* | "Organisations successfully added to shortlist" |
*
* @param {Coinvestments_Addedtoshortlist3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addedtoshortlist3 = /** @type {((inputs?: Coinvestments_Addedtoshortlist3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addedtoshortlist3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addedtoshortlist3(inputs)
});
export { coinvestments_addedtoshortlist3 as "coInvestments_addedToShortlist" }